/**
 * LOT A — Téléchargement des exports (XLSX structuré ou CSV).
 * Point d'entrée unique côté front : ajoute le paramètre `format`,
 * déduit l'extension et déclenche le téléchargement.
 */
import axios from 'axios';

export const EXPORT_FORMATS = [
  { value: 'xlsx', label: 'Excel (.xlsx)', hint: 'Mise en forme, montants calculables' },
  { value: 'csv', label: 'CSV (.csv)', hint: 'Import comptable / ERP' },
];

export async function downloadExport(endpoint, { format = 'xlsx', filenameBase = 'export', axiosConfig = {} } = {}) {
  const sep = endpoint.includes('?') ? '&' : '?';
  const url = `${endpoint}${sep}format=${format}&t=${Date.now()}`;
  const res = await axios.get(url, {
    responseType: 'blob',
    ...axiosConfig,
    headers: { 'Cache-Control': 'no-cache', ...(axiosConfig.headers || {}) },
  });
  const date = new Date().toISOString().split('T')[0];
  const filename = `${filenameBase}_${date}.${format === 'xlsx' ? 'xlsx' : 'csv'}`;
  triggerBlobDownload(res.data, filename);
  return filename;
}

export async function downloadExportPost(endpoint, { format = 'xlsx', filenameBase = 'export', payload = {}, axiosConfig = {} } = {}) {
  const sep = endpoint.includes('?') ? '&' : '?';
  const url = `${endpoint}${sep}format=${format}`;
  const res = await axios.post(url, payload, {
    responseType: 'blob',
    ...axiosConfig,
    headers: { 'Cache-Control': 'no-cache', ...(axiosConfig.headers || {}) },
  });
  const date = new Date().toISOString().split('T')[0];
  const filename = `${filenameBase}_${date}.${format === 'xlsx' ? 'xlsx' : 'csv'}`;
  triggerBlobDownload(res.data, filename);
  return filename;
}

export function triggerBlobDownload(data, filename) {
  const objectUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = objectUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}
